import React from 'react'
import { Typography } from '@mui/material'

const EmptyView: React.FC = () => <Typography>No upcoming webinar sessions found.</Typography>

export default EmptyView
